module.exports = __webpack_public_path__ + "images/emoji/white_large_square.5e01fc067b249770ecea.png";